import client from '../utils/client'
import { gql } from '@apollo/client'
import { CURRENT_USER_QUERY } from '../utils/user'

type Error = 'NETWORK_ERROR' | 'INVALID_EMAIL_ADDRES' | 'INVALID_LOCATION_ID'

const updateRestaurantCommunity = async ({
	type,
	restaurantId,
	communityId,
	customMinOrderValueInCents,
	customDeliveryFeeDefaultInCents,
	nSubOrdersPerOrder,
	closingMinutesBeforeDelivery,
}: {
	type: 'ACTIVATE' | 'DEACTIVATE' | 'UPDATE' | 'CREATE'
	restaurantId: string
	communityId: string
	customMinOrderValueInCents?: number | null
	customDeliveryFeeDefaultInCents?: number | null
	nSubOrdersPerOrder?: number | null
	closingMinutesBeforeDelivery?: number | null
}):Promise<{ success: true; error: undefined } | { success: false; error: Error }> => {
	try {
		const { errors } = await client.mutate({
			mutation: gql`
				mutation UpdateRestaurantCommunity(
					$type: UpdateType!
					$restaurantId: ID!
					$communityId: ID!
					$customMinOrderValueInCents: Int
					$customDeliveryFeeDefaultInCents: Int
					$nSubOrdersPerOrder: Int
					$closingMinutesBeforeDelivery: Int
				) {
					updateRestaurantCommunity(
						type: $type
						restaurantId: $restaurantId
						communityId: $communityId
						customMinOrderValueInCents: $customMinOrderValueInCents
						customDeliveryFeeDefaultInCents: $customDeliveryFeeDefaultInCents
						nSubOrdersPerOrder: $nSubOrdersPerOrder
						closingMinutesBeforeDelivery: $closingMinutesBeforeDelivery
					) {
						success
					}
				}
			`,
			variables: {
				type,
				restaurantId,
				communityId,
				customMinOrderValueInCents,
				customDeliveryFeeDefaultInCents,
				nSubOrdersPerOrder,
				closingMinutesBeforeDelivery,
			},
			refetchQueries: [{ query: CURRENT_USER_QUERY }],
			awaitRefetchQueries: true,
		})
		if (errors) {
			return { success: false, error: errors[0]?.message as Error }
		}
		return {
			success: true,
			error: undefined,
		}
	} catch (e) {
		if (e && e.networkError) return { success: false, error: 'NETWORK_ERROR' }
		throw e
	}
}

export default updateRestaurantCommunity
